import{dew}from"js/dist/offcanvas.js";export default dew();